<template>
  <UiCheckbox
    v-for="item of typesAvailable"
    :key="item.value"
    :label="item.label"
    :isChecked="isChecked(item.value)"
    class="filter-format__checkbox"
    @inputValue="toggleCheckbox(item.value)"
  >
    <template #hint>
      {{ item.description }}
    </template>
  </UiCheckbox>
</template>

<script setup lang="ts">
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
  import type { TFormatValue } from '../../types/format';
  import { useFormatTypes } from '../../composables/useFormatTypes';
  import { locales } from '../../i18n';
  import type { TExcursionFiltersTourFormat } from '@/entities/filter/store/types/excursion/state.ts';

  interface Props {
    isExperiment?: boolean;
  }

  const props = withDefaults(defineProps<Props>(), {
    isExperiment: false,
  });

  const filtersStore = useExcursionFiltersStore();

  const { typesAvailable } = useFormatTypes(
    locales.ru,
    computed(() => props.isExperiment),
  );

  const FORMAT_TO_TOUR_MAP: Record<TFormatValue, TExcursionFiltersTourFormat[number]> = {
    'private,tour_private': 'tour_private',
    'group,tour_group': 'tour_group',
    'minigroup,tour_minigroup': 'tour_minigroup',
  };

  function isChecked(value: TFormatValue) {
    return filtersStore.state.type.includes(value);
  }

  function toggleCheckbox(value: TFormatValue) {
    const { type, tourFormat } = filtersStore.state;
    const currentlyChecked = type.includes(value);
    const tourValue = FORMAT_TO_TOUR_MAP[value];

    if (currentlyChecked) {
      filtersStore.state.type = type.filter((item) => item !== value);
      filtersStore.state.tourFormat = tourFormat.filter((t) => t !== tourValue);
    } else {
      filtersStore.state.type = [...type, value];

      if (!tourFormat.includes(tourValue)) {
        filtersStore.state.tourFormat = [...tourFormat, tourValue];
      }
    }
  }

  // TODO: нужно разобраться с checked, и при reset настроить сброс checked
</script>

<style scoped lang="scss">
  @use '@experience/design-tokens/typography' as typography;

  .filter-format__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;

    :deep(.checkbox__label) {
      @include typography.base-400-400-regular;
    }
  }
</style>
